<template>
    <div class="product_data_tab">
        <template v-if="loading">
            <Loading/>
        </template>
        <div class="product_data_tab-selections">
            <div class="product_data_tab-title">{{ $t('editorScenePriceConfig') }}</div>
            <div 
                v-for="(selection, index) in selections"
                :key="selection.id"
                class="product_data_tab-selections-item"
            >
                <label>{{ selection.name }}</label>
                <select
                    v-model="selectionsModels[index][selection.id]"
                    @change="updateProductValues"
                >
                    <option
                        v-for="option in selection.values"
                        :key="option.id"
                        :value="option.id"
                        :disabled="option.disabled"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div
            class="product_data_tab-price-selections"
            v-if="priceObject !== null"
        >
            <div class="product_data_tab-selections-item">
                <label>{{ priceObject.name }}</label>
                <select
                    v-model="priceModel[0][priceObject.id]"
                    @change="showPriceSubOptions(priceModel[0][priceObject.id])"
                >
                    <option
                        v-for="option in priceObject.values"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="product_data_tab-selections-item">
                <label>{{ priceSelections.subOption.name }}</label>
                <select
                    v-model="priceSubOptionModel[0][priceSelections.subOption.id]"
                    @change="recalculatePriceSubOptions(priceSubOptionModel[0][priceSelections.subOption.id])"
                >
                    <option
                        v-for="option in priceSelections.subOption.values"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div
            v-if="price.netPrice !== null"
            class="product_price"
        >
            <div class="product_data_tab-title">{{ $t('editorScenePriceSummary') }}</div>
            <div class="product_price-netto">{{ $t('editorScenePriceNet') }} <span>{{ price.netPrice }}</span></div>
            <div class="product_price-VAT">{{ $t('editorScenePriceVAT') }} <span>{{ price.tax }}</span></div>
            <div class="product_price-gross">{{ $t('editorScenePriceTotal') }} <span>{{ price.currency }} {{ price.grossPrice }}</span></div>
        </div>
        <saveProjectBtn />
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { RepositoryFactory } from '../../repositories/repositoryFactory';
    const ProductRepository = RepositoryFactory.get('product');
    const SessionRepository = RepositoryFactory.get('session');
    import saveProjectBtn from '../Scene/ElementsOptions/saveProject.vue';
    import { messenger, handlers as messengerHandlers } from '../../js/messenger';
    import { uuid } from 'vue-uuid';
    import Loading from '../Global/Loading.vue'

    export default {
        data() {
            return {
                selections: [],
                selectionsModels: [],
                selectionsModelsForEditor: [],
                priceObject: null,
                priceModel: [],
                priceSelections: null,
                priceSubOptionModel: [],
                price: {
                    currency: null,
                    grossPrice: null,
                    netPrice: null,
                    tax: null,
                    taxRate: null
                },
                loading: false
            }
        },
        computed: {
            ...mapState([
                'sessionToken'
            ]),
            ...mapGetters([
                'getPages',
                'getProject'
            ]),
        },
        methods: {
            recalculateParams() {
                const params = {};
                this.selectionsModels.forEach(selection => {
                    Object.assign(params, selection)
                });
                return JSON.stringify(params);
            },
            recalculateParamsForEditor() {
                const params = {};
                this.selectionsModels.forEach(selection => {
                    Object.assign(params, selection)
                });
                if (this.priceModel.length > 0) {
                    this.priceModel.forEach(selection => {
                        Object.assign(params, selection)
                    });
                }

                if (this.priceSubOptionModel.length > 0) {
                    this.priceSubOptionModel.forEach(selection => {
                        Object.assign(params, selection)
                    });
                }

                return JSON.stringify(params);
                // return JSON.parse(JSON.stringify(params));
            },
            async updateProductValues() {
                this.loading = true;
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.sessionToken.token
                }
                try {
                    const availableConfig = await ProductRepository.getAvailableOptions(headers, this.recalculateParams());
                    const newConfig = availableConfig.data.data.validSetup;

                    const array = [];
                    this.selections.forEach(select => {
                        const s = {};
                        s[select.id] = newConfig[select.id];
                        array.push(s);
                    });

                    this.selectionsModels = array;

                    const availableOptions = availableConfig.data.data.availableOptions;
                    
                    this.selections.forEach(selection => {
                        selection.values.map(val => {
                            val.disabled = true;
                        })
                    });

                    Object.keys(availableOptions).forEach(value => {
                        const sel =  this.selections.find(selection => selection.id === value);
                        const availableValues = availableOptions[value];
                        availableValues.forEach(value => {
                            const r = sel.values.find(val => val.id === parseInt(value));
                            r.disabled = false;
                        })
                    });

                    const price = await this.priceMethod();
                    this.updatePrice(price);

                    const editorValues = await this.editorValuesMethod();

                    if (editorValues.templateFormat !== null) {
                        const templateData = {
                            id: editorValues.templateFormat.id,
                            name: editorValues.templateFormat.name,
                            pageWidth: editorValues.templateFormat.pageWidth,
                            pageHeight: editorValues.templateFormat.pageHeight,
                            pageBleed: editorValues.templateFormat.pageBleed
                        };
                        const projectData = {
                            ...this.getProject,
                            templateFormatId: editorValues.templateFormat.id
                        }
                        this.$store.dispatch('ADD_TEMPLATE_DATA', templateData);
                        this.$store.dispatch('ADD_PROJECT_DATA', projectData)
                    }
                    
                    const pageCount = parseInt(editorValues.pageCount);
                    const currentPageCount = this.getPages.length;

                    if (pageCount > currentPageCount) {
                        const pagesToAdd = pageCount - currentPageCount;

                        for (let i = 0; i < pagesToAdd; i++) {
                            this.$store.dispatch('DISABLE_ELEMENTS_ON_PAGE');
                            this.$store.dispatch('CHANGE_ACTIVE_ELEMENT', {})
                            
                            let newPage = {
                                html: null,
                                content: {
                                    id: uuid.v1(),
                                    isActive: true,
                                    elements: [],
                                    zIndex: 0,
                                    pageColor: {
                                        rgb: 'rgb(255, 255, 255)',
                                        hex: 'FFFFFF',
                                        X: 0,
                                        Y: 150
                                    },
                                    pageRadius: 0,
                                    isLocked: false,
                                    backgroundImage: {
                                        url: null,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat'
                                    }
                                }
                            }
                            this.$store.dispatch('ADD_NEW_PAGE', newPage);
                            this.$store.dispatch('CHANGE_PAGE_TRANSITION', 1)
                        }
                    }

                    if (pageCount < currentPageCount) {
                        const pagesToRemove = currentPageCount - pageCount;

                        const pagesToRemoveIds = this.getPages.slice(pageCount).map(page => {
                            return page.content.id;
                        })

                        pagesToRemoveIds.forEach(pageId => {
                            this.$store.dispatch('REMOVE_PAGE', pageId);
                            this.$store.dispatch('CHANGE_ACTIVE_ELEMENT', {});
                            this.$store.dispatch('CHANGE_PAGE_TRANSITION', -1)
                        })

                        this.$store.dispatch('SET_CURRENT_PAGE', this.getPages[0].content.id);
                        
                    }
                    this.loading = false;
                }
                catch(err) {
                    console.log(err)
                }
            },
            updatePrice(productValues) {
                if (productValues.priceOptionTree !== undefined) {
                    this.priceObject = productValues.priceOptionTree;
                    const priceModelObj = {};
                    priceModelObj[this.priceObject.id] = this.priceObject.values[0].id;
                    this.priceModel = [];
                    this.priceModel.push(priceModelObj);
                    this.showPriceSubOptions(this.priceModel[0][this.priceObject.id]);
                } else {
                    this.price = {
                        currency: productValues.currency,
                        grossPrice: productValues.grossPrice,
                        netPrice: productValues.netPrice,
                        tax: productValues.tax,
                        taxRate: productValues.taxRate
                    }
                }
            },
            showPriceSubOptions(selectedPriceValue) {
                const selectedPriceOption = this.priceObject.values.find(val => val.id === selectedPriceValue);
                
                this.priceSelections = selectedPriceOption;
                this.priceSubOptionModel = [];
                const priceSubOptionModelObj = {};
                priceSubOptionModelObj[this.priceSelections.subOption.id] = this.priceSelections.subOption.values[0].id;
                this.priceSubOptionModel.push(priceSubOptionModelObj);

                this.recalculatePriceSubOptions(this.priceSubOptionModel[0][this.priceSelections.subOption.id])
            },
            async recalculatePriceSubOptions(subOption) {
                const chosenSubOption = this.priceSelections.subOption.values.find(val => val.id === subOption)
                this.price = {
                    currency: chosenSubOption.currency,
                    grossPrice: chosenSubOption.grossPrice,
                    netPrice: chosenSubOption.netPrice,
                    tax: chosenSubOption.tax,
                    taxRate: chosenSubOption.taxRate
                }
                const editorParams = await this.editorValuesMethod();
            },
            async editorValuesMethod() {
                this.loading = true;
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.sessionToken.token
                }
                try {
                    const editorValuesResponse = await ProductRepository.getEditorValues(headers, this.recalculateParamsForEditor());

                    const editorValues = editorValuesResponse.data.data;

                    messenger.sendProductUpdateMessage(JSON.parse(this.recalculateParamsForEditor()));

                    this.loading = false;

                    return editorValues;
                }
                catch(err) {
                    console.log(err)
                }
            },
            async priceMethod() {
                this.loading = true;
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.sessionToken.token
                }
                try {
                    const priceResponse = await ProductRepository.getPrice(headers, this.recalculateParams());

                    const price = priceResponse.data.data;
                    this.loading = false;

                    return price;
                }
                catch(err) {
                    console.log(err)
                }
            }
        },
        async created() {
            this.loading = true;
            const headers = {
                'api-key' : 'session',
                'api-sign' : this.sessionToken.token
            }

            try {
                const productDetails = await ProductRepository.getProductDetails(headers);

                const selections = productDetails.data.data.options;

                selections.map(select => {
                    select.values.forEach(value => {
                        value.disabled = false;
                    })

                    return select;
                });

                this.selections = productDetails.data.data.options;

                this.selections.forEach(select => {
                    const s = {};
                    s[select.id] = productDetails.data.data.default_setup[select.id];
                    this.selectionsModels.push(s);
                })

                this.updateProductValues();
                this.loading = false;
            }
            catch(err) {
                console.log(err);
            }
        },
        components: {
            saveProjectBtn,
            Loading
        }
    }
</script>

<style lang="scss" scoped>
    .product_data_tab {
        // width: 300px;
        height: 100vh;
        background-color: #fff;
        color: #777777;
        border: 1px solid #D4D4D4;
        box-sizing: border-box;
        padding: 15px 0;
        overflow-y: auto;
    }
    .product_data_tab-title {
        color: #B7B7B7;
        text-transform: uppercase;
        margin-bottom: 15px;
        font-size: 16px;
        line-height: 21px;
    }
    .product_data_tab-selections-item {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin: 10px 0;
        font-size: 14px;
    }
    .product_data_tab-selections-item label {
        margin-bottom: 8px;
    }
    .product_data_tab-selections-item select {
        border-radius: 5px;
        border: 1px solid #dfdfdf;
        padding: 3px;
        background-color: #fbfbfb;
        color: #818181;
        font-family: inherit;
    }
    .product_data_tab-selections-item select option:disabled {
        color: #b3b3b3;
    }
    .product_data_tab-selections,
    .product_data_tab-price-selections,
    .product_price {
        padding: 0 15px;
    }
    .product_price {
        color: #331b48;
        margin-top: 30px;
        padding-top: 30px;
        border-top: 1px solid #D4D4D4;
        padding-top: 30px;
    }
    .product_price-netto,
    .product_price-VAT,
    .product_price-gross {
        color: #707070;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    .product_price-gross {
        color: var(--primary-color);
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
    }
    @media (max-width: 1200px) {
        .product_data_tab-title,
        .product_data_tab-selections-item,
        .product_data_tab-selections-item select {
            font-size: 12px;
        }
    }
</style>